import { Button } from 'darrius';
import { useContext } from 'react';
import { CheckoutContext } from '../../../context/Checkout';
import { customTracking } from '../../../utils/customTracking';
import { type IPurchaseCardProps } from './@interfaces';
import { PurchaseMenu } from './PurchaseMenu/PurchaseMenu';

import styles from './PurchaseCard.module.scss';

export const PurchaseCard = ({
  id,
  nameId,
  title,
  totalCoins,
  totalPrice,
  installmentsLabel,
  installmentsDetails,
  appButton,
  origin,
  paymentCards,
  isCreditCardMpActive = false,
  isPixMpActive = false,
  userState = '',
  isPagaLeveActive,
  userInfo,
  changePagarmeToPagaleve,
}: IPurchaseCardProps) => {
  const { updateCheckoutData, checkoutData } = useContext(CheckoutContext);
  const { currentBundleName } = checkoutData;
  const activeBundle = checkoutData.bundlesData.find(
    (bundle) => bundle.nameId === nameId
  );
  const bundlePosition = checkoutData.bundlesData.indexOf(activeBundle) + 1;

  const bundleTrialsIds = [135];
  const bundleId = id || 0;
  const CONSUMER_WEEK_BUNDLE_ID = 9999;

  const PROMOTIONAL_TEXT = 'Ganhe 50% de moedas extras';
  const PROMOTIONAL_TEXT_CONSUMER_WEEK =
    'Desconto de 11% - Semana do Consumidor';
  const DEFAULT_BUNDLE_TEXT = '2x mais chance de fechar um serviço';
  const bundleText =
    id === CONSUMER_WEEK_BUNDLE_ID
      ? PROMOTIONAL_TEXT_CONSUMER_WEEK
      : PROMOTIONAL_TEXT;

  const textToShow = bundleTrialsIds.includes(bundleId)
    ? bundleText
    : DEFAULT_BUNDLE_TEXT;

  function handleClickBuyBundle() {
    updateCheckoutData((oldState) => ({
      ...oldState,
      currentBundleName: nameId,
    }));

    customTracking({
      schema: 'iglu:br.com.getninjas/bundle_click/jsonschema/1-0-0',
      data: {
        bundles_count: checkoutData.bundlesData.length,
        profile_id: checkoutData.profile.id,
        bundle_id: activeBundle.id,
        bundle_position: bundlePosition,
      },
    });
  }

  return (
    <div className={`purchase-card ${styles['purchase-card']} `}>
      <div className={`purchase-card__body ${styles['purchase-card__body']} `}>
        <p
          className={`purchase-card__title ${styles['purchase-card__title']} `}
        >
          {title}
        </p>
        <div
          className={`purchase-card__content ${styles['purchase-card__content']} `}
        >
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/coins.svg`}
            alt="Icone amarelo de moedas"
          />
          <div>
            <p>{totalCoins}</p>
            {currentBundleName === nameId && (
              <p
                className={`purchase-card__label ${styles['purchase-card__label']} `}
              >
                {installmentsLabel}
              </p>
            )}
          </div>
        </div>
        <div
          className={`purchase-card__highlight ${styles['purchase-card__highlight']} `}
        >
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/icon-check.svg`}
            alt="Icone verde de confirmação"
          />
          <p>{textToShow}</p>
        </div>
      </div>

      {currentBundleName === nameId ? (
        <PurchaseMenu
          appButton={appButton}
          origin={origin}
          paymentCards={paymentCards}
          isCreditCardMpActive={isCreditCardMpActive}
          isPixMpActive={isPixMpActive}
          userState={userState}
          isPagaLeveActive={isPagaLeveActive}
          userInfo={userInfo}
          changePagarmeToPagaleve={changePagarmeToPagaleve}
        />
      ) : (
        <div
          className={`purchase-card__footer ${styles['purchase-card__footer']} `}
        >
          <div>
            {id === CONSUMER_WEEK_BUNDLE_ID ? (
              <>
                <p>
                  <span
                    style={{
                      textDecoration: 'line-through',
                    }}
                  >
                    R$ 89,90
                  </span>{' '}
                  <span
                    className={`purchase-card__footer--title ${styles['purchase-card__footer--title']} `}
                  >
                    R$ 79,90
                  </span>
                </p>
                <p>
                  3x de
                  <strong> R$ 26,64</strong>
                </p>
              </>
            ) : (
              <>
                <p>
                  {installmentsDetails.installmentCount} x de
                  <span
                    className={`purchase-card__footer--title ${styles['purchase-card__footer--title']} `}
                  >
                    {installmentsDetails.installmentValue}
                  </span>
                </p>
                <p>À vista {totalPrice}</p>
              </>
            )}
          </div>
          <Button.Root
            type="button"
            variation="primary"
            onClick={handleClickBuyBundle}
          >
            Comprar
          </Button.Root>
        </div>
      )}
    </div>
  );
};
